import React from "react";
import { Select, Segmented, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "../recommended.module.css";

const { Option } = Select;

export default function TopFilterBar({ filters, onFilterChange }) {
  const handleChange = (key, value) => {
    onFilterChange({ [key]: value });
  };

  return (
    <div className={styles.filterBar}>
      <Select
        value={filters.make}
        onChange={(value) => handleChange("make", value)}
        bordered={false}
      >
        <Option value="Toyota">Toyota</Option>
        <Option value="Honda">Honda</Option>
        <Option value="Ford">Ford</Option>
      </Select>

      <Select
        value={filters.model}
        onChange={(value) => handleChange("model", value)}
        bordered={false}
      >
        <Option value="Camry">Camry</Option>
        <Option value="Accord">Accord</Option>
        <Option value="F-150">F-150</Option>
      </Select>

      <Select
        value={filters.yearRange}
        onChange={(value) => handleChange("yearRange", value)}
        bordered={false}
      >
        <Option value="2019-2022">2019-2022</Option>
        <Option value="2020-2023">2020-2023</Option>
        <Option value="2018-2021">2018-2021</Option>
      </Select>

      <Select
        value={filters.location}
        onChange={(value) => handleChange("location", value)}
        bordered={false}
      >
        <Option value="Fremont, CA +75 mi">Fremont, CA +75 mi</Option>
        <Option value="San Jose, CA +75 mi">San Jose, CA +75 mi</Option>
        <Option value="Oakland, CA +75 mi">Oakland, CA +75 mi</Option>
      </Select>

      <Select
        value={filters.priceRange}
        onChange={(value) => handleChange("priceRange", value)}
        bordered={false}
      >
        <Option value="$8k-$22k">$8k-$22k</Option>
        <Option value="$10k-$25k">$10k-$25k</Option>
        <Option value="$5k-$20k">$5k-$20k</Option>
      </Select>

      <Segmented
        options={["30D", "60D", "90D"]}
        value={filters.domPeriod}
        onChange={(value) => handleChange("domPeriod", value)}
        className={styles.domSegmented}
      />

      <Button
        type="text"
        icon={<SearchOutlined />}
        className={styles.searchButton}
      />
    </div>
  );
}

